import React from 'react'
import { isSjDomain , isKsDomain } from 'utils/domain'

import SjGlobalHeader from './SjGlobalHeader'
import KsGlobalHeader from './KsGlobalHeader'

/**
 * グローバルヘッダー・全ての画面に適用するヘッダー
 */
const GlobalHeaderArea: React.FC = () => {
  return <React.Fragment>{isSjDomain() && <SjGlobalHeader />}{isKsDomain() && <KsGlobalHeader />}</React.Fragment>
}

export default GlobalHeaderArea
